"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _LearningView = _interopRequireDefault(require("./LearningView"));
var _Chart = _interopRequireDefault(require("./Chart"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _DataTable = _interopRequireDefault(require("../DataTable"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var classes = exports.classes = ['ai_learning_train', 'ai_learning_number', 'number_learning_attr_1', 'number_learning_attr_2', 'number_learning_attr_3', 'number_learning_attr_4', 'number_learning_attr_5', 'number_learning_attr_6'];
var _attrLength = /*#__PURE__*/new WeakMap();
var _trainParam = /*#__PURE__*/new WeakMap();
var _table = /*#__PURE__*/new WeakMap();
var _trainCallback = /*#__PURE__*/new WeakMap();
var _chart = /*#__PURE__*/new WeakMap();
var _isTrained = /*#__PURE__*/new WeakMap();
var _chartEnable = /*#__PURE__*/new WeakMap();
var _view = /*#__PURE__*/new WeakMap();
var _predictResult = /*#__PURE__*/new WeakMap();
var _name = /*#__PURE__*/new WeakMap();
var _fields = /*#__PURE__*/new WeakMap();
var _predictField = /*#__PURE__*/new WeakMap();
var _loadModel = /*#__PURE__*/new WeakMap();
var NumberClassification = /*#__PURE__*/function () {
  function NumberClassification() {
    var _this = this;
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, NumberClassification);
    _classPrivateFieldInitSpec(this, _attrLength, 0);
    _classPrivateFieldInitSpec(this, _trainParam, null);
    _classPrivateFieldInitSpec(this, _table, {});
    _classPrivateFieldInitSpec(this, _trainCallback, void 0);
    _classPrivateFieldInitSpec(this, _chart, null);
    _classPrivateFieldInitSpec(this, _isTrained, false);
    _classPrivateFieldInitSpec(this, _chartEnable, false);
    _classPrivateFieldInitSpec(this, _view, null);
    _classPrivateFieldInitSpec(this, _predictResult, null);
    _classPrivateFieldInitSpec(this, _name, '');
    _classPrivateFieldInitSpec(this, _fields, []);
    _classPrivateFieldInitSpec(this, _predictField, []);
    _classPrivateFieldInitSpec(this, _loadModel, void 0);
    _classPrivateFieldSet(_view, this, new _LearningView["default"]({
      name: params.name || '',
      status: 0
    }));
    // 정지시 data 초기화.
    Entry.addEventListener('stop', function () {
      _this.init(_objectSpread({}, params));
    });
    this.init(_objectSpread({}, params));
  }
  return (0, _createClass2["default"])(NumberClassification, [{
    key: "init",
    value: function init(_ref) {
      var _this2 = this,
        _table$select,
        _table$select2,
        _table$select3;
      var name = _ref.name,
        url = _ref.url,
        table = _ref.table,
        trainParam = _ref.trainParam,
        modelId = _ref.modelId,
        loadModel = _ref.loadModel,
        result = _ref.result;
      _classPrivateFieldSet(_name, this, name);
      _classPrivateFieldSet(_table, this, table);
      this.result = result;
      _classPrivateFieldSet(_trainCallback, this, function (value) {
        _classPrivateFieldGet(_view, _this2).setValue(value);
      });
      _classPrivateFieldSet(_isTrained, this, true);
      _classPrivateFieldSet(_loadModel, this, loadModel);
      _classPrivateFieldSet(_attrLength, this, (table === null || table === void 0 || (_table$select = table.select) === null || _table$select === void 0 || (_table$select = _table$select[0]) === null || _table$select === void 0 ? void 0 : _table$select.length) || 0);
      _classPrivateFieldSet(_fields, this, table === null || table === void 0 || (_table$select2 = table.select) === null || _table$select2 === void 0 || (_table$select2 = _table$select2[0]) === null || _table$select2 === void 0 ? void 0 : _table$select2.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      }));
      _classPrivateFieldSet(_predictField, this, table === null || table === void 0 || (_table$select3 = table.select) === null || _table$select3 === void 0 || (_table$select3 = _table$select3[1]) === null || _table$select3 === void 0 ? void 0 : _table$select3.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      }));
      if (_classPrivateFieldGet(_attrLength, this) === 2) {
        _classPrivateFieldSet(_chartEnable, this, true);
      }
      if (this.url !== url || this.modelId !== modelId) {
        // load시 trainParam에 추가되는 파라미터가 있어서 로드 직전 추가.
        _classPrivateFieldSet(_trainParam, this, trainParam);
        this.load(url, modelId);
        this.url = url;
        this.modelId = modelId;
      }
    }
  }, {
    key: "setTable",
    value: function setTable() {
      var _classPrivateFieldGet2, _tableSource$fields;
      var tableSource = _DataTable["default"].getSource(_classPrivateFieldGet(_table, this).id);
      if (((_classPrivateFieldGet2 = _classPrivateFieldGet(_table, this)) === null || _classPrivateFieldGet2 === void 0 || (_classPrivateFieldGet2 = _classPrivateFieldGet2.fieldsInfo) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.length) !== (tableSource === null || tableSource === void 0 || (_tableSource$fields = tableSource.fields) === null || _tableSource$fields === void 0 ? void 0 : _tableSource$fields.length)) {
        Entry.toast.alert(Lang.Msgs.warn, Lang.AiLearning.train_param_error);
        throw Error(Lang.AiLearning.train_param_error);
      }
      _classPrivateFieldGet(_table, this).data = tableSource.rows;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldGet(_view, this).destroy();
      if (_classPrivateFieldGet(_chart, this)) {
        _classPrivateFieldGet(_chart, this).destroy();
        _classPrivateFieldSet(_chart, this, null);
      }
    }
  }, {
    key: "createColor",
    value: function createColor() {
      return _classPrivateFieldGet(_trainParam, this).labels.reduce(function (acc, cur, idx, arr) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, cur, Entry.Utils.randomColor()));
      }, {});
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      _classPrivateFieldGet(_view, this).setVisible(visible);
    }
  }, {
    key: "unbanBlocks",
    value: function unbanBlocks(blockMenu) {
      blockMenu.unbanClass("ai_learning_train");
      blockMenu.unbanClass("ai_learning_number");
      blockMenu.unbanClass("number_learning_attr_".concat(_classPrivateFieldGet(_attrLength, this)));
      if (_classPrivateFieldGet(_chartEnable, this)) {
        blockMenu.unbanClass('ai_learning_train_chart');
      }
    }
  }, {
    key: "isTrained",
    value: function isTrained() {
      return _classPrivateFieldGet(_isTrained, this);
    }
  }, {
    key: "openChart",
    value: function openChart() {
      if (!_classPrivateFieldGet(_chartEnable, this)) {
        return;
      }
      if (!_classPrivateFieldGet(_chart, this)) {
        _classPrivateFieldSet(_chart, this, new _Chart["default"]({
          title: Lang.AiLearning.chart_title,
          description: "<em>".concat(Lang.AiLearning["class"], "</em>   ").concat(_classPrivateFieldGet(_predictField, this)[0], "<em>").concat(Lang.AiLearning.model_attr_str, " 1</em>").concat(_classPrivateFieldGet(_fields, this)[0], "<em>").concat(Lang.AiLearning.model_attr_str, " 2</em>").concat(_classPrivateFieldGet(_fields, this)[1]),
          source: this.chartData
        }));
      } else {
        _classPrivateFieldGet(_chart, this).show();
      }
    }
  }, {
    key: "closeChart",
    value: function closeChart() {
      var _classPrivateFieldGet3;
      (_classPrivateFieldGet3 = _classPrivateFieldGet(_chart, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.hide();
    }
  }, {
    key: "setTrainOption",
    value: function setTrainOption(type, value) {
      this.trainParam = _objectSpread(_objectSpread({}, this.trainParam), {}, (0, _defineProperty2["default"])({}, type, value));
    }
  }, {
    key: "getTrainOption",
    value: function getTrainOption() {
      return _classPrivateFieldGet(_trainParam, this);
    }
  }, {
    key: "getResult",
    value: function getResult() {
      return _classPrivateFieldGet(_predictResult, this);
    }
  }, {
    key: "getTrainResult",
    value: function getTrainResult() {
      return this.result;
    }
  }, {
    key: "getLabels",
    value: function getLabels() {
      var _convertTableToKnnDat = convertTableToKnnData(_classPrivateFieldGet(_table, this)),
        trainData = _convertTableToKnnDat.data,
        labels = _convertTableToKnnDat.labels;
      return (0, _uniq2["default"])(labels[0]).sort(function (a, b) {
        return String(a).localeCompare(String(b));
      });
    }
  }, {
    key: "train",
    value: function train() {
      var _classPrivateFieldGet4;
      this.setTable();
      _classPrivateFieldGet(_trainCallback, this).call(this, 1);
      _classPrivateFieldSet(_isTrained, this, false);
      var _convertTableToKnnDat2 = convertTableToKnnData(_classPrivateFieldGet(_table, this)),
        trainData = _convertTableToKnnDat2.data,
        labels = _convertTableToKnnDat2.labels;
      var trainLabels = labels[0];
      var uniqLabels = (0, _uniq2["default"])(labels[0]).sort(function (a, b) {
        return String(a).localeCompare(String(b));
      });
      var numLabels = uniqLabels.length;
      var maxVector = new Array(trainData[0].length).fill(-Infinity);
      trainData.forEach(function (e) {
        for (var i = 0; i < maxVector.length; i++) {
          maxVector[i] = maxVector[i] > e[i] ? maxVector[i] : e[i];
        }
      });
      var minVector = new Array(trainData[0].length).fill(Infinity);
      trainData.forEach(function (e) {
        for (var i = 0; i < minVector.length; i++) {
          minVector[i] = minVector[i] < e[i] ? minVector[i] : e[i];
        }
      });
      _classPrivateFieldSet(_trainParam, this, _objectSpread(_objectSpread({}, _classPrivateFieldGet(_trainParam, this)), {}, {
        trainData: trainData,
        trainLabels: trainLabels,
        labels: uniqLabels,
        numLabels: numLabels,
        maxVector: maxVector,
        minVector: minVector
      }));
      _classPrivateFieldSet(_isTrained, this, true);
      this.colors = this.createColor();
      (_classPrivateFieldGet4 = _classPrivateFieldGet(_chart, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.load({
        source: this.chartData
      });
      _classPrivateFieldGet(_trainCallback, this).call(this, 100);
    }
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url, modelId) {
        var savedData;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _classPrivateFieldGet(_loadModel, this).call(this, {
                url: url,
                modelId: modelId
              });
            case 1:
              savedData = _context.sent;
              if (savedData) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _classPrivateFieldSet(_trainParam, this, _objectSpread(_objectSpread({}, _classPrivateFieldGet(_trainParam, this)), {}, {
                trainData: savedData.data,
                trainLabels: savedData.labels,
                labels: (0, _uniq2["default"])(savedData.labels).sort(function (a, b) {
                  return String(a).localeCompare(String(b));
                }),
                maxVector: savedData.maxVector,
                minVector: savedData.minVector,
                numLabels: savedData.numLabels,
                neighbors: savedData.neighbors,
                isLoaded: true
              }));
              this.colors = this.createColor();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "normalize",
    value: function normalize() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var normData = [];
      var _classPrivateFieldGet5 = _classPrivateFieldGet(_trainParam, this),
        minVector = _classPrivateFieldGet5.minVector,
        maxVector = _classPrivateFieldGet5.maxVector;
      for (var i = 0; i < data.length; i++) {
        normData.push((data[i] - minVector[i]) / (maxVector[i] - minVector[i]));
      }
      return normData;
    }
  }, {
    key: "predict",
    value: function predict(data) {
      var distData = [];
      var _classPrivateFieldGet6 = _classPrivateFieldGet(_trainParam, this),
        trainData = _classPrivateFieldGet6.trainData,
        trainLabels = _classPrivateFieldGet6.trainLabels,
        neighbors = _classPrivateFieldGet6.neighbors;
      for (var i = 0; i < trainData.length; i++) {
        var dist = eudist(this.normalize(data), this.normalize(trainData[i]));
        distData.push({
          index: i,
          dist: dist,
          label: trainLabels[i]
        });
      }
      distData.sort(function (a, b) {
        return a.dist - b.dist;
      });
      var counts = {};
      for (var _i = 0; _i < neighbors; _i++) {
        var _distData$_i = distData[_i],
          label = _distData$_i.label,
          _dist = _distData$_i.dist;
        if (!counts[label]) {
          counts[label] = [];
        }
        counts[label].push(_dist);
      }
      var totalDistance = (0, _sum2["default"])(Object.values(counts).flat());
      _classPrivateFieldSet(_predictResult, this, Object.keys(counts).map(function (className) {
        var dist = (0, _mean2["default"])(counts[className]);
        var count = counts[className].length;
        var distProbability = totalDistance === 0 ? 1 : (totalDistance - dist) / totalDistance;
        var probability = count / neighbors * 99 + distProbability;
        return {
          className: className,
          count: count,
          probability: probability
        };
      }).sort(function (a, b) {
        return b.probability - a.probability;
      }));
      return _classPrivateFieldGet(_predictResult, this);
    }
  }, {
    key: "findLabel",
    value: function findLabel(x, y) {
      var strX = String(x);
      var strY = String(y);
      var index = _classPrivateFieldGet(_trainParam, this).trainData.findIndex(function (row) {
        return String(row[0]) === strX && String(row[1]) === strY;
      });
      return _classPrivateFieldGet(_trainParam, this).trainLabels[index];
    }
  }, {
    key: "findColor",
    value: function findColor(id, a, b) {
      if (id === 'y') {
        return this.colors[this.findLabel(a, b)];
      }
      return undefined;
    }
  }, {
    key: "chartData",
    get: function get() {
      var _this3 = this;
      var json = _classPrivateFieldGet(_trainParam, this).trainData.map(function (row, idx) {
        return {
          x: row[0],
          y: row[1],
          index: _classPrivateFieldGet(_trainParam, _this3).trainLabels[idx]
        };
      });
      return {
        data: {
          type: 'scatter',
          json: json,
          keys: {
            value: ['y'],
            x: 'x'
          },
          color: function color(_color, d) {
            return _this3.findColor(d.id, d.x, d.value) || _color;
          },
          labels: false
        },
        options: {
          point: {
            pattern: ['circle']
          },
          legend: {
            show: false
          },
          tooltip: {
            contents: function contents(data) {
              var _data = (0, _slicedToArray2["default"])(data, 1),
                _data$ = _data[0],
                x = _data$.x,
                value = _data$.value;
              var label = _this3.findLabel(x, value);
              return "\n                        <div class=\"chart_handle_wrapper\">\n                            ".concat(Lang.AiLearning["class"], ": ").concat(label, ", ").concat(_classPrivateFieldGet(_fields, _this3)[0], ": ").concat(x, ", ").concat(_classPrivateFieldGet(_fields, _this3)[1], ": ").concat(value, "\n                        <div>");
            }
          },
          axis: {
            x: {
              tick: {
                fit: false,
                count: 10
              }
            }
          },
          grid: {
            x: {
              show: true
            },
            y: {
              show: true
            }
          }
        }
      };
    }
  }]);
}();
var _default = exports["default"] = NumberClassification;
function eudist(a, b) {
  var sum = 0;
  for (var i = 0; i < a.length; i++) {
    var d = (a[i] || 0) - (b[i] || 0);
    sum += d * d;
  }
  return sum;
}
function convertTableToKnnData() {
  var tableData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _tableData$select = tableData.select,
    select = _tableData$select === void 0 ? [[0], [1]] : _tableData$select,
    _tableData$data = tableData.data,
    table = _tableData$data === void 0 ? [] : _tableData$data;
  var _select = (0, _slicedToArray2["default"])(select, 2),
    attr = _select[0],
    predict = _select[1];
  var filtered = table.filter(function (row) {
    return !select[0].some(function (selected) {
      return (0, _isNaN2["default"])((0, _toNumber2["default"])(row[selected]));
    });
  });
  return filtered.reduce(function (accumulator, row) {
    var _accumulator$data = accumulator.data,
      data = _accumulator$data === void 0 ? [] : _accumulator$data,
      _accumulator$labels = accumulator.labels,
      labels = _accumulator$labels === void 0 ? [] : _accumulator$labels;
    return {
      data: [].concat((0, _toConsumableArray2["default"])(data), [row.filter(function (data, index) {
        return attr.includes(index);
      })]),
      labels: predict.map(function (i, idx) {
        var arr = labels[idx] || [];
        return [].concat((0, _toConsumableArray2["default"])(arr), [row[i]]);
      })
    };
  }, {
    data: [],
    labels: []
  });
}